(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = fixedSidebar

/*
 * Fixed sidebar. Detects whether a fixed sidebar
 * has got too long to remain fixed, and changes its
 * class to enable styles to keep it viewable.
 */
function fixedSidebar (view, $sidebar) {

  if (!$sidebar || !$sidebar.length) return

  function isSidebarFixed () {

    var sidebarHeight = $sidebar.height()
      , sidebarOffset = $sidebar.offset().top
      , windowHeight = $(window).height()

    if (sidebarHeight + sidebarOffset > windowHeight) {
      $sidebar.addClass('panel-unfixed')
    } else {
      $sidebar.removeClass('panel-unfixed')
    }

  }

  $(window).on('resize', isSidebarFixed)

  view.on('remove', function () {
    $(window).off('resize', isSidebarFixed)
  })

  isSidebarFixed()

}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/fixed-sidebar.js","/admin/source/js/app/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFkbWluL3NvdXJjZS9qcy9hcHAvbGliL2ZpeGVkLXNpZGViYXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0EiLCJmaWxlIjoiZ2VuZXJhdGVkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXNDb250ZW50IjpbIm1vZHVsZS5leHBvcnRzID0gZml4ZWRTaWRlYmFyXG5cbi8qXG4gKiBGaXhlZCBzaWRlYmFyLiBEZXRlY3RzIHdoZXRoZXIgYSBmaXhlZCBzaWRlYmFyXG4gKiBoYXMgZ290IHRvbyBsb25nIHRvIHJlbWFpbiBmaXhlZCwgYW5kIGNoYW5nZXMgaXRzXG4gKiBjbGFzcyB0byBlbmFibGUgc3R5bGVzIHRvIGtlZXAgaXQgdmlld2FibGUuXG4gKi9cbmZ1bmN0aW9uIGZpeGVkU2lkZWJhciAodmlldywgJHNpZGViYXIpIHtcblxuICBpZiAoISRzaWRlYmFyIHx8ICEkc2lkZWJhci5sZW5ndGgpIHJldHVyblxuXG4gIGZ1bmN0aW9uIGlzU2lkZWJhckZpeGVkICgpIHtcblxuICAgIHZhciBzaWRlYmFySGVpZ2h0ID0gJHNpZGViYXIuaGVpZ2h0KClcbiAgICAgICwgc2lkZWJhck9mZnNldCA9ICRzaWRlYmFyLm9mZnNldCgpLnRvcFxuICAgICAgLCB3aW5kb3dIZWlnaHQgPSAkKHdpbmRvdykuaGVpZ2h0KClcblxuICAgIGlmIChzaWRlYmFySGVpZ2h0ICsgc2lkZWJhck9mZnNldCA+IHdpbmRvd0hlaWdodCkge1xuICAgICAgJHNpZGViYXIuYWRkQ2xhc3MoJ3BhbmVsLXVuZml4ZWQnKVxuICAgIH0gZWxzZSB7XG4gICAgICAkc2lkZWJhci5yZW1vdmVDbGFzcygncGFuZWwtdW5maXhlZCcpXG4gICAgfVxuXG4gIH1cblxuICAkKHdpbmRvdykub24oJ3Jlc2l6ZScsIGlzU2lkZWJhckZpeGVkKVxuXG4gIHZpZXcub24oJ3JlbW92ZScsIGZ1bmN0aW9uICgpIHtcbiAgICAkKHdpbmRvdykub2ZmKCdyZXNpemUnLCBpc1NpZGViYXJGaXhlZClcbiAgfSlcblxuICBpc1NpZGViYXJGaXhlZCgpXG5cbn1cbiJdfQ==